import request from '@/utils/request'
import api from '@/api'
import {
  setLocalItem,
  getLocalItem,
  clearLocalItem
} from '@/utils/auth'
const getDefaultState = () => {
  return {
    instList: getLocalItem(api.keys.instList),                          //平台列表
    productList:getLocalItem(api.keys.productList),                     //平台产品列表
    creditorList:getLocalItem(api.keys.creditorList),                   //资方列表
    creditorProductList:getLocalItem(api.keys.creditorProductList),     //资方列表
    platformNo:getLocalItem(api.keys.platformNo),                       //选中的平台机构号
  }
}
const state = getDefaultState()

const mutations = {
  SET_INST: (state, data) => {
    state.instList = data
  },
  SET_PRODUCT: (state, data) => {
    state.productList = data
  },
  SET_CREDITOR: (state, data) => {
    state.creditorList = data
  },
  SET_CREDITORPRODUCT: (state, data) => {
    state.creditorProductList = data
  },
  SET_PLATFORMNO: (state, data) => {
    state.platformNo = data
  },
}

const actions = {
  // 获取平台信息
  getInstList({ commit }) {
    return new Promise((resolve, reject) => {
      request.get(api.common.instSelectCur,{ instType:2 }).then(res => {
        const { data } = res
        commit('SET_INST', data)
        setLocalItem(api.keys.instList, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 平台产品信息
  getProductList({ commit }) {
    return new Promise((resolve, reject) => {
      request.post(api.common.productSelect).then(res => {
        const { data } = res
        commit('SET_PRODUCT', data)
        setLocalItem(api.keys.productList, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
   // 资方信息列表
   getCreditorList({ commit }) {
    return new Promise((resolve, reject) => {
      request.get(api.common.instSelectCur,{ instType:3 }).then(res => {
        const { data } = res
        commit('SET_CREDITOR', data)
        setLocalItem(api.keys.creditorList, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
   // 资方产品列表
   getCreditorProductList({ commit }) {
    return new Promise((resolve, reject) => {
      request.post(api.common.creditorSelect).then(res => {
        const { data } = res
        commit('SET_CREDITORPRODUCT', data)
        setLocalItem(api.keys.creditorProductList, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //存储平台机构号
  setPlatformNo({ commit },option) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        //1.成功调用resolve
        commit('SET_PLATFORMNO', option.platformNo)
        setLocalItem(api.keys.platformNo, option.platformNo)
        resolve('success')
    },1)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
